import React, { forwardRef } from 'react';

import Tooltip from 'common/uiV3/Tooltip';
import { iconLinkClass } from './AdminV2NavIconLink';

import type { LucideIcon } from 'lucide-react';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  Icon: LucideIcon;
  label: string;
  active?: boolean;
}

const AdminV2NavIconButton = forwardRef<HTMLButtonElement, Props>(
  ({ Icon, label, active = false, ...props }: Props, ref) => {
    return (
      <Tooltip>
        <Tooltip.Trigger asChild>
          <button
            ref={ref}
            aria-label={label}
            data-active={active ? true : undefined}
            className={iconLinkClass}
            {...props}>
            <Icon className="text-secondary-foreground" />
          </button>
        </Tooltip.Trigger>
        <Tooltip.Content align="center" side="right">
          {label}
        </Tooltip.Content>
      </Tooltip>
    );
  },
);

export default AdminV2NavIconButton;
